import { useEffect, useState, useCallback } from 'react';
import dayjs from 'dayjs';
import debounce from 'lodash.debounce';
import { DatePicker, Image, Input, message, Spin } from 'antd';
import api from '@/api/report';
import Pagination from '@/components/pagination';
import { disabledDate } from '@/utils/publicMethod';
import { calendarIcon, searchIcon } from '@/constants/static';
const Report = () => {
    const [tableTab, setTableTab] = useState(1);
    const { RangePicker } = DatePicker;
    const [loading, setLoading] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [tableData, setTableData] = useState<any[]>([]);
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        keyword: '',
        feedbackType: 'report',
    });
    const inputChange = e => {
        setListParams(state => ({ ...state, keyword: e.target.value, pageNum: 1 }));
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => {
            getList(nextValue);
            syncTabCounts(nextValue);
        }, 1500),
        []
    );
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
        getList({ ...listParams, pageNum: prop });
    };
    const dateOnChange = date => {
        const nextParams = {
            ...listParams,
            pageNum: 1,
            startTime: date ? dayjs(`${dayjs(date[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString() : '',
            endTime: date ? dayjs(`${dayjs(date[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString() : '',
        };
        getList(nextParams);
        syncTabCounts(nextParams);
        setListParams(nextParams);
    };
    const [tabCounts, setTabCounts] = useState({ report: 0, argument: 0 });
    const syncTabCounts = async (params: typeof listParams) => {
        try {
            const shared = { ...params, pageNum: 1, pageSize: 1 };
            const [reportRes, argumentRes] = await Promise.all([
                api.getReportList({ ...shared, feedbackType: 'report' }),
                api.getReportList({ ...shared, feedbackType: 'argument' }),
            ]);
            setTabCounts({
                report: +reportRes.data.total,
                argument: +argumentRes.data.total,
            });
        } catch {
            // getList handles user-facing errors
        }
    };
    const [expandKey, setEexpandKey] = useState<number[]>([]);
    const expandKeyChange = (key: number) => {
        if (expandKey.includes(key)) {
            setEexpandKey(expandKey.filter(i => i !== key));
        } else {
            setEexpandKey(state => [...state, key]);
        }
    };
    const getList = async params => {
        setLoading(true);
        try {
            const res = await api.getReportList(params);
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    createTime: item.createTime ? window.utils.formatTimeHMDY(item.createTime) : '-',
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setTableData(list);
            setTotalRecord(+res.data.total);
            setTabCounts(state => ({
                ...state,
                [params.feedbackType]: +res.data.total,
            }));
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getList({ ...listParams });
        syncTabCounts(listParams);
    }, []);
    return (
        <div className="page-main account">
            <div className="page-title">Payout</div>
            <div className="select-bar">
                <RangePicker
                    className="search-input"
                    placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                    suffixIcon={calendarIcon}
                    separator={'-'}
                    format={'DD/MM/YYYY'}
                    disabledDate={disabledDate}
                    onChange={dateOnChange}
                />
                <Input
                    className="search-input"
                    placeholder="Search by task"
                    onChange={inputChange}
                    prefix={searchIcon}
                />
            </div>
            <div className="table">
                <div className="tabs-table" style={{ margin: '24px 0', columnGap: '72px' }}>
                    <div
                        className={tableTab === 1 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'}
                        onClick={() => {
                            setTableTab(1);
                            setListParams({ ...listParams, feedbackType: 'report' });
                            getList({ ...listParams, feedbackType: 'report' });
                        }}
                    >
                        Report ({tabCounts.report})
                    </div>
                    <div
                        className={tableTab === 2 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'}
                        onClick={() => {
                            setTableTab(2);
                            setListParams({ ...listParams, feedbackType: 'argument' });
                            getList({ ...listParams, feedbackType: 'argument' });
                        }}
                    >
                        Argument ({tabCounts.argument})
                    </div>
                </div>
                {loading ? (
                    <div className="data_loading flex-center">
                        <Spin />
                    </div>
                ) : tableData.length ? (
                    <>
                        <div className="report-feedback-list">
                            {tableData.map((item, e) => {
                                return (
                                    <div className="content-card" key={e}>
                                        <div className="card-title">
                                            Task: {item.taskTitle ?? '-'}
                                            <img
                                                src={require('@/assets/images/open-menu.png')}
                                                alt="open-menu"
                                                className={
                                                    expandKey.includes(e) ? 'arrowTransformReturn' : 'arrowTransform'
                                                }
                                                onClick={() => {
                                                    expandKeyChange(e);
                                                }}
                                            />
                                        </div>
                                        <div className="card-item-label">
                                            <div>
                                                Customer: <span>{item.customer ? item.customer.fullName : '-'}</span>
                                            </div>
                                            <div>
                                                Tasker: <span>{item.tasker ? item.tasker.fullName : '-'}</span>
                                            </div>
                                        </div>
                                        <div className="card-item-label">
                                            <div>
                                                Task Date: <span>{item.taskWorkTime ?? '-'}</span>
                                            </div>
                                            <div>
                                                Report Date: <span>{item.createTime ?? '-'}</span>
                                            </div>
                                        </div>
                                        {expandKey.includes(e) ? (
                                            <>
                                                {item.feedbackImg.length ? (
                                                    <>
                                                        <div className="card-item-label photos-label">Photos</div>
                                                        <div className="photos-box">
                                                            {item.feedbackImg.map((val, k) => {
                                                                return (
                                                                    <Image
                                                                        key={k}
                                                                        src={
                                                                            val
                                                                                ? val
                                                                                : 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
                                                                        }
                                                                    />
                                                                );
                                                            })}
                                                        </div>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                                <div className="card-item-label message-label">Messages</div>
                                                <div className="message-box">{item.feedbackContent ?? '-'}</div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        <Pagination total={totalRecord} pageChange={handlePageChange} pageNo={listParams.pageNum} />
                    </>
                ) : (
                    <div className="no-data flex-center">No data</div>
                )}
            </div>
        </div>
    );
};
export default Report;
